/** Tags de quêtes — filtres + création obligatoire (≥1) */
export const QUEST_TAGS = [
  { id: 'civisme', label: 'Civisme', icon: '🏛️', color: '#9CA3AF' },
  { id: 'service', label: 'Service', icon: '🤝', color: '#10B981' },
  { id: 'aide', label: 'Aide', icon: '💬', color: '#3B82F6' },
  { id: 'chasse', label: 'Chasse', icon: '⚔️', color: '#DC2626' },
  { id: 'exploration', label: 'Exploration', icon: '🗺️', color: '#F59E0B' },
  { id: 'evenement', label: 'Événement', icon: '🍻', color: '#c9951a' }
];

export function getQuestTags(quest: any) {
  if (quest?.tags?.length) return quest.tags;
  if (quest?.type) return [quest.type];
  return ['exploration'];
}

export function tagLabel(tagId: string) {
  return QUEST_TAGS.find((t) => t.id === tagId)?.label || tagId;
}

export function tagIcon(tagId: string) {
  return QUEST_TAGS.find((t) => t.id === tagId)?.icon || '📜';
}

/** Les quêtes publiques sont émises directement ; seuls les mandats gardent un escrow. */
export function isQuestFunded(quest: any) {
  if (!quest) return false;
  const reward = quest.recompense || 0;
  if (quest.playerFunded && (quest.escrowPaid ?? 0) >= reward) return true;
  if (quest.communityFunded && (quest.escrowPaid ?? 0) >= reward) return true;
  if (!quest.playerFunded && !quest.communityFunded) return true;
  return false;
}
